import { useContext } from "react";
import Accordion from "react-bootstrap/Accordion";
import AccordionContext from "react-bootstrap/AccordionContext";
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";

import Card from "react-bootstrap/Card";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";

function AccordionAwareToggle({ classNameTitle, eventKey, title }) {
  const currentEventKey = useContext(AccordionContext);

  const isCurrentEventKey = currentEventKey === eventKey;

  const decoratedOnClick = useAccordionToggle(eventKey);

  return (
    <div className="d-flex justify-content-between align-items-center">
      <button className="btn" type="button" onClick={decoratedOnClick}>
        <h3 className={`mb-0 ${classNameTitle || ""}`}>{title}</h3>
      </button>

      {isCurrentEventKey ? (
        <BiChevronUp className="dropdown-icon" />
      ) : (
        <BiChevronDown className="dropdown-icon" />
      )}
    </div>
  );
}

function AccordionDropdown({
  className,
  classNameTitle,
  classNameCard,
  title,
  activeKey,
  children,
}) {
  return (
    <Accordion
      className={`accordion-dropdown ${className || ""}`}
      defaultActiveKey={activeKey}
    >
      <Card className={`border-0 ${classNameCard || ""}`}>
        <Accordion.Toggle
          className="bg-white border-bottom"
          as={Card.Header}
          eventKey={activeKey}
        >
          <AccordionAwareToggle
            classNameTitle={classNameTitle}
            eventKey={activeKey}
            title={title}
          />
        </Accordion.Toggle>

        <Accordion.Collapse eventKey={activeKey}>
          <Card.Body className="p-0">{children}</Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
}

export default AccordionDropdown;
